/**
 * Escala oficial dos controles de seleção do Hub TransGrãos.
 *
 * As alturas partem do controle small já usado no produto (40 px). A variante
 * compacta cabe nas grades sem alterar a altura da linha; a ampla dá mais área
 * de toque a formulários destacados. Larguras são uma escala fechada para que
 * barras equivalentes não inventem medidas por tela.
 */
export const selectTokens = {
  height: {
    compact: 32,
    standard: 40,
    spacious: 48,
  },
  width: {
    xs: 132,
    sm: 160,
    md: 200,
    lg: 280,
    xl: 360,
    form: 560,
  },
  menu: {
    maxHeight: 320,
    viewportGutter: 12,
    optionHeight: 40,
  },
  debounceMs: 280,
  pageSize: 50,
} as const

export type SelectControlSize = keyof typeof selectTokens.height
export type SelectControlWidth = keyof typeof selectTokens.width | 'full'

export function selectWidth(width: SelectControlWidth): number | string {
  return width === 'full' ? '100%' : selectTokens.width[width]
}
